<template>
    <ContainerContent
        class="mb-16"
        outer-container
    >
        <v-row>
            <v-col>
                <h1
                    v-if="heading"
                    class="page-title"
                >
                    {{ heading }}
                </h1>
            </v-col>
        </v-row>

        <div
            class="mt-8"
        >
            <LegacyContentItems :items="contentData.sectionData"></LegacyContentItems>
        </div>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import LegacyContentItems from '~/components/content/LegacyContentItems/LegacyContentItems.server.vue';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';
    import type { ContentData, ContentMeta, Page } from '~/types';

    const props = defineProps<{
        contentMeta: ContentMeta
        contentData: Extract<ContentData, Page>
        pageKey: string;
    }>();

    // Page heading (H1). Page-specific overrides win; otherwise the content meta
    // heading (`h1`), NOT `title` — `title` is now the document <title>.
    const heading = computed<Nilish<string>>(() =>
        props.contentData.header ||
        props.contentData.title ||
        props.contentMeta.h1
    );
</script>

<style lang="scss" scoped></style>
